// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3k4d-","filesListContainer":"PosDisputesFiles_filesListContainer__29JL_","filesButton":"PosDisputesFiles_filesButton__UV9Ti"};